import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Informação de pagamentos',
    payouts: 'Pagamentos',
  },
  form: {
    invoicing_emails: {
      label: 'Enviar faturas para',
      placeholder: 'Introduza o seu e-mail',
    },
    payout_schedule: {
      label: 'Calendário de pagamentos',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Pagamentos pausados',
        [PAYOUT_INTERVAL.DAILY]: 'Pagamentos diários',
        [PAYOUT_INTERVAL.WEEKLY]: 'Pagamentos semanais',
        [PAYOUT_INTERVAL.MONTHLY]: 'Pagamentos mensais',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurante',
    amount: 'Valor',
    cash_amount: 'Valor em dinheiro',
    paypal_standalone_amount: 'Valor PayPal',
    period: 'Período',
    paid_at: 'Pago em',
    provider: 'Fornecedor',
    status: 'Estado',
    actions: 'Ações',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Dinheiro',
    system: 'Sistema',
  },
  buttons: {
    save: 'Guardar',
    actions: 'Ações',
    open_report: 'Abrir relatório',
    open_tracking_url: 'Rastrear pagamento',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'Pendente',
    [PAYOUT_STATUSES.processing]: 'Em processamento',
    [PAYOUT_STATUSES.paid]: 'Pago',
    [PAYOUT_STATUSES.failed]: 'Falhado',
    undefined: 'Desconhecido',
    null: 'Desconhecido',
  },
  toasts: {
    failed_to_load_data: 'Falha ao obter dados',
    successfully_updated: 'Atualizado com sucesso',
  },
};
